import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import List from '../../components/Crud/List';
import { useAuth } from '../../contexts/auth';

import styles from './TransactionNaturesIndex.module.scss';

type TransactionNatureModel = {
  id: number;
  name: string;
  description: string;
};

export default function TransactionNaturesIndex() {
  const [isLoading, setIsLoading] = useState(true);
  const [transactionNatures, setTransactionNatures] = useState(
    [] as TransactionNatureModel[]
  );

  const {
    user: { organization },
  } = useAuth();

  async function getTransactionNatures() {
    if (organization) {
      setIsLoading(true);
      const response = await api.get(
        `organizations/${organization.id}/transaction-natures`
      );
      setTransactionNatures(response.data.data);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getTransactionNatures();
  }, [organization]);

  return (
    <List isLoading={isLoading} title='Naturezas da Operação' newItemUrl='new'>
      <table className='table table-hover'>
        <thead>
          <tr>
            <th scope='col'>#</th>
            <th scope='col'>Nome</th>
            <th scope='col'>Descrição</th>
          </tr>
        </thead>
        <tbody>
          {transactionNatures.map((i) => {
            return (
              <tr key={i.id}>
                <th scope='row'>{i.id}</th>
                <td>
                  <Link to={`${i.id}/edit`}>{i.name}</Link>
                </td>
                <td className={styles.description}>
                  <div title={i.description}>{i.description}</div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </List>
  );
}
